import type { UrlParamAliasSet } from "@/lib/attribution/url-param-aliases"

export type ChannelMatcherField =
  | "utm_source"
  | "utm_medium"
  | "utm_campaign"
  | "utm_term"
  | "utm_content"
  | "referrer_url"
  | "referrer_domain"
  | "referral_code"
  | "discount_code"
  | "shopify_source"
  | "shopify_source_type"

export type ChannelMatcherOperator = "contains" | "equals" | "starts_with" | "ends_with"

/** Field order of the matcher editor. */
export const SUPPORTED_MATCHER_FIELDS: ChannelMatcherField[] = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "referrer_url",
  "referrer_domain",
  "referral_code",
  "discount_code",
  "shopify_source",
  "shopify_source_type",
]

export const CHANNEL_MATCHER_FIELD_LABELS: Record<ChannelMatcherField, string> = {
  utm_source: "UTM source",
  utm_medium: "UTM medium",
  utm_campaign: "UTM campaign",
  utm_term: "UTM term",
  utm_content: "UTM content",
  referrer_url: "Referrer URL",
  referrer_domain: "Referrer domain",
  referral_code: "Referral code",
  discount_code: "Discount code",
  shopify_source: "Shopify source",
  shopify_source_type: "Shopify source type",
}

export const SUPPORTED_MATCHER_OPERATORS: ChannelMatcherOperator[] = ["contains", "equals", "starts_with", "ends_with"]

export interface ChannelMatcherDTO {
  id?: string
  field: ChannelMatcherField
  operator: ChannelMatcherOperator
  value: string
  order: number
  isAnyValue?: boolean
  matcherGroupId?: number | null  // Logical group ID for OR logic between groups. null = legacy field-based grouping
  isNegated?: boolean  // NOT logic: when true, matcher passes if condition does NOT match
}

export interface ChannelSourceDTO {
  id?: string
  slug: string
  label: string
  order: number
  matchers: ChannelMatcherDTO[]
}

export interface ChannelConfigDTO {
  id?: string
  slug: string
  label: string
  color?: string | null
  priority: number
  allowChannelLevelExpense: boolean
  isFallback?: boolean
  isSpecial?: boolean
  matchers?: ChannelMatcherDTO[]
  sources: ChannelSourceDTO[]
}

export interface ChannelConfigResponse {
  channelSetId?: string | null
  version: string
  channels: ChannelConfigDTO[]
  isDefault: boolean
  // null = platform default alias sets apply
  paramAliasSets: UrlParamAliasSet[] | null
}

export interface ChannelConfigSaveRequest {
  version?: string
  channels: ChannelConfigDTO[]
  // absent = keep stored value; null = reset to platform defaults; array = replace
  paramAliasSets?: UrlParamAliasSet[] | null
}
